import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { replaceWithRegion } from 'actions/NavigationActions'
import { addRegionToPath } from 'lib/url/searchUrlUtils'
import { LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'

const BASE_PATH = `/${LUXURY_PLUS_PATHS.DEFAULT_LANDING_PAGE}`

function useLuxPlusLandingTab(
  validTabs: ReadonlyArray<string>,
  defaultTab: string,
): {
  activeTab: string
  navigateToTab: (tab: string) => void
} {
  const { tab: urlTab } = useParams<{ tab?: string }>()
  const dispatch = useAppDispatch()
  const regionCode = useAppSelector(state => state.geo.currentRegionCode)

  const resolveTab = (raw: string | undefined) =>
    raw !== undefined && validTabs.includes(raw) ? raw : defaultTab

  const [activeTab, setActiveTab] = useState(() => resolveTab(urlTab))

  useEffect(() => {
    if (urlTab !== undefined && !validTabs.includes(urlTab)) {
      dispatch(replaceWithRegion(`${BASE_PATH}/${defaultTab}`))
    }
  }, [urlTab, validTabs, defaultTab, dispatch])

  const navigateToTab = useCallback((tab: string) => {
    setActiveTab(tab)
    // Used to alter URL without completely reloading components, page, and scroll position
    window.history.replaceState(null, '', addRegionToPath(`${BASE_PATH}/${tab}`, regionCode))
  }, [regionCode])

  return { activeTab, navigateToTab }
}

export default useLuxPlusLandingTab
